import { useStaticQuery, graphql } from "gatsby"

export const usePressArticles = () => {
  const query = useStaticQuery(
    graphql`
      query PressArticles {
        allContentfulPressArticle(
          sort: { fields: [datePublished], order: DESC }
        ) {
          nodes {
            id
            title
            publication
            category
            datePublished
            articleLink
            featured
            summary {
              summary
            }
            image {
              description
              title
              file {
                url
              }
            }
          }
        }
      }
    `
  )
  return query.allContentfulPressArticle.nodes
}
